/* eslint-disable @typescript-eslint/naming-convention */
export class Environment {
  public static VALUES = ['Marine', 'Freshwater', 'Terrestrial'];
}
